import React, { useMemo, useCallback } from 'react';
import { Image, useStyleProps, View, Button, Icon, Accordion, Modal, withAdditionalTheme, useTheme } from '@flive/react-kit';
import md5 from 'md5';
import arrowRight from '@flive/react-kit/icons/arrow-right.svg';
import close from '@flive/react-kit/icons/close.svg';
var _excluded = ["gravatarEmail"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var calcGravatarHash = function calcGravatarHash(email) {
  return md5(email.toLowerCase().trim());
};
/**
 * @group NavigationDrawer
 * @extends View
 * @howtoimport import NavigationDrawer from '@flive/react-navigation-drawer';
 * NavigationDrawer.Gravatar
 * @maturity experimental
 */


var Gravatar = function Gravatar(_ref) {
  var gravatarEmail = _ref.gravatarEmail,
      rest = _objectWithoutProperties(_ref, _excluded);

  var source = "https://www.gravatar.com/avatar/".concat(calcGravatarHash(gravatarEmail), "?d=identicon");
  return /*#__PURE__*/React.createElement(Image, _extends({
    source: source
  }, rest));
};

Gravatar.displayName = 'NavigationDrawer.Gravatar';
var _excluded$1 = ["onClose", "children", "linkComponent", "avatarIdentifier", "avatarImgSource", "avatarAlternateText", "renderAvatar", "lazyLoading"];

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$1(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/**
 * @group NavigationDrawer
 * @extends View
 * @howtoimport import NavigationDrawer from '@flive/react-navigation-drawer';
 * NavigationDrawer.Header
 * @maturity experimental
 */


var Header = function Header(_ref) {
  var onClose = _ref.onClose,
      children = _ref.children,
      linkComponent = _ref.linkComponent,
      avatarIdentifier = _ref.avatarIdentifier,
      avatarImgSource = _ref.avatarImgSource,
      avatarAlternateText = _ref.avatarAlternateText,
      renderAvatar = _ref.renderAvatar,
      lazyLoading = _ref.lazyLoading,
      rest = _objectWithoutProperties$1(_ref, _excluded$1);

  var avatar;
  var onClickButtonClose = useMemo(function () {
    return function (event) {
      event.preventDefault();
      onClose();
    };
  }, [onClose]);

  var avatarProps = _objectSpread(_objectSpread({
    alt: avatarAlternateText
  }, useStyleProps({
    path: 'navigationDrawer.avatar'
  })), {}, {
    lazyLoading: lazyLoading
  });

  if (typeof avatarImgSource === 'string') {
    avatar = /*#__PURE__*/React.createElement(Image, _extends$1({
      source: avatarImgSource
    }, avatarProps));
  } else if (typeof avatarIdentifier === 'string') {
    avatar = renderAvatar(avatarIdentifier || '', avatarProps);
  }

  return /*#__PURE__*/React.createElement(View, useStyleProps(_objectSpread({
    as: linkComponent,
    path: 'navigationDrawer.header',
    onClick: onClose
  }, rest)), /*#__PURE__*/React.createElement(Button, _extends$1({
    variant: "icon",
    as: "button",
    onClick: onClickButtonClose
  }, useStyleProps({
    path: 'navigationDrawer.headerClose'
  }))), avatar, /*#__PURE__*/React.createElement(View, useStyleProps({
    path: 'navigationDrawer.headerContent'
  }), /*#__PURE__*/React.createElement(View, useStyleProps({
    path: 'navigationDrawer.headerText'
  }), children), /*#__PURE__*/React.createElement(Icon, useStyleProps({
    path: 'navigationDrawer.headerIcon'
  }))));
};

Header.displayName = 'NavigationDrawer.Header';
Header.defaultProps = {
  avatarAlternateText: 'Profile image',
  avatarIdentifier: undefined,
  avatarImgSource: undefined,
  lazyLoading: false,
  linkComponent: 'a',
  onClose: undefined,
  // eslint-disable-next-line react/no-multi-comp
  renderAvatar: function renderAvatar(avatarIdentifier, avatarProps) {
    return /*#__PURE__*/React.createElement(Gravatar, _extends$1({
      gravatarEmail: avatarIdentifier
    }, avatarProps));
  }
};
var _excluded$2 = ["menuLinks", "onClickLink", "linkComponent", "level"],
    _excluded2 = ["label", "key", "children"];

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$2(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var MAX_LEVEL = 4;
var Item = Accordion.Item,
    Link = Accordion.Link;
/**
 * @group NavigationDrawer
 * @extends View
 * @howtoimport import NavigationDrawer from '@flive/react-navigation-drawer';
 * NavigationDrawer.AccordionMenu
 * @maturity experimental
 */

var AccordionMenu = function AccordionMenu(_ref) {
  var menuLinks = _ref.menuLinks,
      onClickLink = _ref.onClickLink,
      linkComponent = _ref.linkComponent,
      level = _ref.level,
      rest = _objectWithoutProperties$2(_ref, _excluded$2);

  return /*#__PURE__*/React.createElement(Accordion, rest, menuLinks.map(function (_ref2) {
    var label = _ref2.label,
        key = _ref2.key,
        children = _ref2.children,
        item = _objectWithoutProperties$2(_ref2, _excluded2);

    if (Array.isArray(children)) {
      return level < MAX_LEVEL && /*#__PURE__*/React.createElement(Item, _extends$2({
        key: key || label,
        label: label
      }, item), /*#__PURE__*/React.createElement(AccordionMenu, {
        menuLinks: children,
        level: level + 1,
        linkComponent: linkComponent,
        onClickLink: onClickLink
      }));
    }

    return /*#__PURE__*/React.createElement(Link, _extends$2({
      key: key || label,
      linkComponent: linkComponent,
      onClick: onClickLink
    }, item), label);
  }));
};

AccordionMenu.displayName = 'NavigationDrawer.AccordionMenu';
AccordionMenu.defaultProps = {
  level: 1,
  linkComponent: 'a',
  onClickLink: undefined
}; // eslint-disable-next-line import/no-unresolved

var navigationDrawer = {
  header: {
    alignItems: 'flex-start',
    backgroundColor: 'primary',
    position: 'relative',
    flexDirection: 'column',
    borderColor: {
      bottom: 'border'
    },
    pseudoClasses: {
      focus: {
        pseudoElements: {
          before: {
            content: '""',
            position: {
              absolute: 'none'
            },
            borderColor: 'invertContent'
          }
        }
      },
      hover: {
        pseudoElements: {
          before: {
            content: '""',
            position: {
              absolute: 'none'
            },
            backgroundColor: 'invertBackground',
            backgroundColorOpacity: 24
          }
        }
      }
    }
  },
  avatar: {
    position: 'relative',
    borderRadius: 'mini-3',
    overflow: 'hidden',
    margin: {
      all: 'mini-2',
      bottom: 'none'
    },
    display: 'block',
    cursor: 'pointer',
    ratio: 1,
    width: 'mini-5',
    backgroundColor: 'transparent',
    textColor: 'currentColor',
    padding: 'none',
    borderColor: 'none',
    outlineColor: 'none',
    outlineOffset: 'mini-1/2',
    cover: true,
    pseudoClasses: {
      focus: {
        outlineColor: 'primary'
      }
    }
  },
  headerClose: {
    position: 'relative',
    iconSvg: close,
    float: 'right',
    size: 'mini-2',
    margin: {
      top: 'mini-1',
      right: 'mini-1'
    },
    display: 'flex',
    borderColor: 'none',
    alignItems: 'center',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    textColor: 'currentColor',
    justifyContent: 'center',
    outlineColor: 'none',
    pseudoClasses: {
      hover: {
        backgroundColorOpacity: 30
      }
    }
  },
  headerContent: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    padding: {
      top: 'mini-1',
      right: 'mini-2',
      bottom: 'mini-2',
      left: 'mini-2'
    },
    alignItems: 'flex-end',
    textAlign: 'left',
    textColor: 'primaryBackground',
    textDecoration: 'none',
    backgroundColor: 'transparent',
    borderColor: 'none',
    outlineColor: 'none',
    pseudoClasses: {
      focus: {
        outlineColor: 'primary'
      }
    }
  },
  headerText: {
    flexGrow: 1,
    fontSize: 'small',
    fontWeight: 'bold',
    cursor: 'pointer'
  },
  headerIcon: {
    svg: arrowRight,
    size: 'mini-2',
    borderColor: 'none',
    backgroundColor: 'transparent',
    width: 'mini-2',
    cursor: 'pointer'
  },
  accordionMenu: {
    margin: 'none',
    boxShadow: 'none'
  }
};
var _excluded$3 = ["userProfile", "menuLinks", "linkComponent", "children"],
    _excluded2$1 = ["content"];

function _extends$3() {
  _extends$3 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$3.apply(this, arguments);
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _objectWithoutProperties$3(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$3(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var renderDefaultHeader = Modal.defaultProps.renderHeader;
/**
 * @group NavigationDrawer
 * @extends View
 * @howtoimport import NavigationDrawer from '@flive/react-navigation-drawer';
 * @maturity experimental
 */

var NavigationDrawer = withAdditionalTheme(navigationDrawer, 'navigationDrawer', function (_ref) {
  var userProfile = _ref.userProfile,
      menuLinks = _ref.menuLinks,
      linkComponent = _ref.linkComponent,
      children = _ref.children,
      props = _objectWithoutProperties$3(_ref, _excluded$3);

  var theme = useTheme();
  var renderMenuHeader = useCallback(function (headerProps) {
    if (_typeof(userProfile) === 'object') {
      var content = userProfile.content,
          profileProps = _objectWithoutProperties$3(userProfile, _excluded2$1);

      return /*#__PURE__*/React.createElement(Header, _extends$3({
        linkComponent: linkComponent,
        onClose: headerProps.handleClose
      }, profileProps), content);
    }

    return renderDefaultHeader(headerProps);
  }, [linkComponent, userProfile]);
  var renderChildren = useCallback(function (childrenProps) {
    if (Array.isArray(menuLinks)) {
      return /*#__PURE__*/React.createElement(AccordionMenu, _extends$3({
        menuLinks: menuLinks,
        linkComponent: linkComponent,
        onClickLink: childrenProps.handleClose
      }, useStyleProps({
        theme: theme,
        path: 'navigationDrawer.accordionMenu'
      })));
    }

    return typeof children === 'function' ? children({
      handleClose: childrenProps.handleClose
    }) : children;
  }, [children, menuLinks, linkComponent, theme]);
  return /*#__PURE__*/React.createElement(Modal, _extends$3({
    anchor: "rightSide",
    renderHeader: renderMenuHeader
  }, props), renderChildren);
});
NavigationDrawer.displayName = 'NavigationDrawer';
NavigationDrawer.defaultProps = {
  linkComponent: 'a',
  menuLinks: undefined,
  userProfile: undefined
};
NavigationDrawer.Gravatar = Gravatar;
NavigationDrawer.Header = Header;
NavigationDrawer.AccordionMenu = AccordionMenu;
export default NavigationDrawer;